import { render, staticRenderFns } from "./SearchResultHighlights.vue?vue&type=template&id=372a4b30&"
import script from "./SearchResultHighlights.vue?vue&type=script&lang=js&"
export * from "./SearchResultHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports